<template>
	<jeet11-distributor :isRummyOptionSelected="true" />
</template>

<script>
import Jeet11Distributor from "../Jeet11Distributor";
export default {
	components: {
		"jeet11-distributor": Jeet11Distributor
	}
};
</script>
